import { useLayoutStore, useUserListStore, useUserRolePermissionStore } from 'contexts/RootStore.context';
import React, { useEffect } from 'react';
import NoPermissionsPage from 'views/NoPermissionsPage';
import { HeaderSearch } from './components/HeaderSearch';
import { UserDataTable } from './components/UserDataTable';
import { observer } from 'mobx-react';
import useDevice from 'hooks/useDevice';
import WidthNotSupportedPage from 'views/WidthNotSupportedPage';

export const RecentUserList = observer(() => {
  const { isMobileDevice } = useDevice();
  const { canViewUsers } = useUserRolePermissionStore()
  const { loadUsers, totalCount, loading, reset, error } = useUserListStore()
  const { setItemCount, setPageError } = useLayoutStore()


  useEffect(() => {
    if (isMobileDevice) {
      return
    }

    const abortController = new AbortController();
    if (canViewUsers) {
      loadUsers(true)
        .finally(() => {
          if (abortController.signal.aborted) {
            reset();
          }
        });
    }

    return () => {
      abortController.abort();
      reset()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setPageError(error)
  }, [error, setPageError])

  useEffect(() => {
    if (!loading) {
      setItemCount(totalCount, "Total Users")
    }
  }, [loading, setItemCount, totalCount])


  if (!canViewUsers) {
    return <NoPermissionsPage />
  }

  if (isMobileDevice) {
    return <WidthNotSupportedPage text='This feature is not available on narrow screens.' />;
  }

  return (
    <>
      <HeaderSearch />
      <UserDataTable />
    </>
  );
})